import { PremiumFeaturesHomePageWrapper } from "app/pages/premium-features/PremiumFeaturesHomePageWrapper";
import { fallback } from "app/routes/handlers/redirectFunctions/fallback";
import { redirectPipe } from "app/routes/handlers/redirectFunctions/redirectPipe";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

export const premiumFeaturesConfig: RouterStateConfig = {
    "premium-features-homepage": {
        parent: "sw",
        url: "/premium-features/home",
        component: PremiumFeaturesHomePageWrapper,
        resolve: {},
        pageId: {
            section: "PremiumFeatures",
            subSection: "homepage",
        },
        redirectTo: redirectPipe(
            fallback({
                digitalsuite: "digitalsuite-home",
            }),
        ),
        trackingId: {
            section: "Premium Features",
            subSection: "homepage",
            subSubSection: "",
        },
        configId: "PremiumSection",
        pageTitle: "premiumfeatures.homepage.title",
        secondaryBarType: "PremiumFeatures",
        hideSecondaryBar: true,
    },
};
